// A v4 UUID for POST /warm-up-groups' client_request_id. Browsers without
// crypto.randomUUID (older Safari) get one built from getRandomValues.
const VERSION_4 = 0x40;
const VARIANT_RFC4122 = 0x80;

const hex = (bytes) => Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");

const uuidFromBytes = (bytes) => {
  bytes[6] = (bytes[6] & 0x0f) | VERSION_4;
  bytes[8] = (bytes[8] & 0x3f) | VARIANT_RFC4122;
  const h = hex(bytes);
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
};

const randomBytes = (count) => {
  const bytes = new Uint8Array(count);
  if (window.crypto?.getRandomValues) return window.crypto.getRandomValues(bytes);
  return bytes.map(() => Math.floor(Math.random() * 256));
};

export const newRequestId = () =>
  window.crypto?.randomUUID ? window.crypto.randomUUID() : uuidFromBytes(randomBytes(16));
